import React from 'react';
import { connectPagination } from 'react-instantsearch-dom';
import Pagination from "material-ui-flat-pagination";


const AlgoliaPagination = ({ currentRefinement, nbPages, refine, createURL }) => {

  const handleClick = (e, offset) => {
    e.preventDefault();
    refine(offset + 1);
  };

  return (
    <Pagination
          limit={1}
          offset={currentRefinement-1}
          total={nbPages}
          onClick={(e, offset) => handleClick(e,offset)}
          size='large'
        />
  );
};

const ConnectedPagination = connectPagination(AlgoliaPagination);
export default ConnectedPagination;



// WEBPACK FOOTER //
// ./src/components/Algolia/ConnectedPagination.js